module.exports = __webpack_public_path__ + "static/other/job_matching.dde9f57a.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/job_matching.json
// module id = 2271
// module chunks = 0